// extracted by mini-css-extract-plugin
export default {"loader":"ViewLoader_loader__2bWt2","smooothpulse":"ViewLoader_smooothpulse__1SKJF"};